var AppointmentStatusFilter = /* @__PURE__ */ ((AppointmentStatusFilter2) => {
  AppointmentStatusFilter2["OPEN_NOT_IN_CLINIC"] = "OPEN_NOT_IN_CLINIC";
  AppointmentStatusFilter2["OPEN_IN_CLINIC"] = "OPEN_IN_CLINIC";
  AppointmentStatusFilter2["WAITING"] = "WAITING";
  AppointmentStatusFilter2["IN_TREATMENT_ROOM"] = "IN_TREATMENT_ROOM";
  AppointmentStatusFilter2["IN_TREATMENT"] = "IN_TREATMENT";
  AppointmentStatusFilter2["TREATED"] = "TREATED";
  AppointmentStatusFilter2["CANCELED"] = "CANCELED";
  AppointmentStatusFilter2["CONTROLLED_PRACTITIONER"] = "CONTROLLED_PRACTITIONER";
  AppointmentStatusFilter2["CONTROLLED_ACCOUNTING"] = "CONTROLLED_ACCOUNTING";
  return AppointmentStatusFilter2;
})(AppointmentStatusFilter || {});
var PatientCreditworthinessStatus = /* @__PURE__ */ ((PatientCreditworthinessStatus2) => {
  PatientCreditworthinessStatus2["CREDITWORTHY"] = "CREDITWORTHY";
  PatientCreditworthinessStatus2["NOT_CREDITWORTHY"] = "NOT_CREDITWORTHY";
  PatientCreditworthinessStatus2["CHECK_IN_PROGRESS"] = "CHECK_IN_PROGRESS";
  PatientCreditworthinessStatus2["EXPIRED"] = "EXPIRED";
  PatientCreditworthinessStatus2["NOT_APPLICABLE_LACK_OF_DATA"] = "NOT_APPLICABLE_LACK_OF_DATA";
  PatientCreditworthinessStatus2["NOT_APPLICABLE_CLINIC"] = "NOT_APPLICABLE_CLINIC";
  PatientCreditworthinessStatus2["NOT_APPLICABLE_CHILD_PATIENT"] = "NOT_APPLICABLE_CHILD_PATIENT";
  PatientCreditworthinessStatus2["NOT_APPLICABLE_LACK_OF_CONSENT"] = "NOT_APPLICABLE_LACK_OF_CONSENT";
  PatientCreditworthinessStatus2["UNKNOWN"] = "UNKNOWN";
  return PatientCreditworthinessStatus2;
})(PatientCreditworthinessStatus || {});
var DocumentStatus = /* @__PURE__ */ ((DocumentStatus2) => {
  DocumentStatus2["DONE"] = "DONE";
  DocumentStatus2["INVALID"] = "INVALID";
  DocumentStatus2["IN_PROGRESS"] = "IN_PROGRESS";
  DocumentStatus2["MISSING"] = "MISSING";
  return DocumentStatus2;
})(DocumentStatus || {});
var ActiveCodeType = /* @__PURE__ */ ((ActiveCodeType2) => {
  ActiveCodeType2["CLINIC"] = "CLINIC";
  ActiveCodeType2["WEB"] = "WEB";
  ActiveCodeType2["SHORT"] = "SHORT";
  ActiveCodeType2["LONG"] = "LONG";
  ActiveCodeType2["SMS"] = "SMS";
  return ActiveCodeType2;
})(ActiveCodeType || {});
var AnamnesisCodeMedium = /* @__PURE__ */ ((AnamnesisCodeMedium2) => {
  AnamnesisCodeMedium2["CLINIC"] = "CLINIC";
  AnamnesisCodeMedium2["EMAIL"] = "EMAIL";
  AnamnesisCodeMedium2["SMS"] = "SMS";
  return AnamnesisCodeMedium2;
})(AnamnesisCodeMedium || {});
var AnamnesisCodeReason = /* @__PURE__ */ ((AnamnesisCodeReason2) => {
  AnamnesisCodeReason2["CLINIC_TRIGGERED"] = "CLINIC_TRIGGERED";
  AnamnesisCodeReason2["OTHER"] = "OTHER";
  return AnamnesisCodeReason2;
})(AnamnesisCodeReason || {});
var AnamnesisCodeCreatorApplication = /* @__PURE__ */ ((AnamnesisCodeCreatorApplication2) => {
  AnamnesisCodeCreatorApplication2["CALMASTER_FRONTEND"] = "CALMASTER_FRONTEND";
  return AnamnesisCodeCreatorApplication2;
})(AnamnesisCodeCreatorApplication || {});
export {
  ActiveCodeType,
  AnamnesisCodeCreatorApplication,
  AnamnesisCodeMedium,
  AnamnesisCodeReason,
  AppointmentStatusFilter,
  DocumentStatus,
  PatientCreditworthinessStatus
};
